import { Enum } from 'enumify'

class InclusionRules extends Enum {}

InclusionRules.initEnum(['INCLUDED', 'CHARGEABLE', 'NOT_INCLUDED'])

export default InclusionRules
